import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const DateField = ({
  label,
  name,
  value,
  onChange,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        className='m-2'
        sx={{
          width: 250,
        }}
        label={label}
        name={name}
        value={value}
        onChange={onChange}
      />
    </LocalizationProvider>
  )
};

export default DateField;